import { useInstance } from '../../support/ioc/useInstance';
import { useEffect } from 'react';
import { ITrackingPage, ITrackingContext, TrackingService } from './TrackingService.ts';

export const usePageView = (pageName: ITrackingPage, getContext?: () => ITrackingContext) => {
    const tracker = useInstance(TrackingService);
    useEffect(() => {
        tracker.startPageView(pageName, getContext);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

};
